import React from 'react';
import { FileText } from 'lucide-react';
import Button from './Button';

const EmptyState = ({ title, description, actionLabel, onAction }) => {
  return (
    <div className="text-center py-12 bg-white rounded-lg border border-gray-200 border-dashed">
      <FileText className="mx-auto h-12 w-12 text-gray-400" />
      <h3 className="mt-2 text-sm font-semibold text-gray-900">{title}</h3>
      <p className="mt-1 text-sm text-gray-500">{description}</p>
      {actionLabel && onAction && (
        <div className="mt-6">
          <Button onClick={onAction} variant="primary">
            {actionLabel}
          </Button>
        </div>
      )}
    </div>
  );
};

export default EmptyState;
